<template>
    <div>
        <b-list-group>
            <b-list-group-item v-for="utente in listaUtenti" :key="utente.uid" class="list-item">
                <b-row>
                    <b-col class="list-item-left"><span> {{utente.first_name}} {{utente.last_name}}</span></b-col>
                    <b-col class="list-item-center"><span> {{utente.email}}</span></b-col>
                    <b-col class="list-item-right">
                        <img src="@/assets/info.svg" class="list-img-info" @click="openEditModal(utente)"/>
                        <img src="@/assets/delete.svg" class="list-img-delete" @click="openUnverifyModal(utente)"/>
                    </b-col>
                </b-row>
            </b-list-group-item>
        </b-list-group>
        <b-modal id="editModal" size="lg" :hide-header="true" button-size="sm" ok-variant="success" cancel-title="Annulla" @ok="updateGroups">
            <EditUserGroups ref="editModal" @closeModal="$bvModal.hide('editModal')" :user="userToEdit" />
        </b-modal>
        <b-modal id="confirmDelete" size="lg" v-if="userToUnverify" :title="userToUnverify.first_name + ' ' + userToUnverify.last_name" button-size="sm" ok-variant="danger" cancel-title="Annulla" @ok="unverifyUser">
            <span> Sei sicuro di voler rimuovere accesso a questo utente?</span>
        </b-modal>
    </div>
</template>

<script>
import EditUserGroups from '@/components/Edit-User-Groups.vue';
import { mixins } from "@/mixins";

export default {
    name: 'ListaUtenti',
    data () {
        return {
            listaUtenti: [],
            userToEdit: Object,
            userToUnverify: Object,
            isSelectionEmpty: false,
        }
    },
    components:{
        EditUserGroups
    },
    mixins: [mixins],
    mounted() {
        this.getUsers();
    },
    methods: {
        openEditModal: function(user){
            this.userToEdit = user;
            this.$bvModal.show('editModal');
        },
        openUnverifyModal: function(user){
            this.userToUnverify = user;
            this.$bvModal.show('confirmDelete');
        },
        updateGroups: function(bvModalEvt){
            bvModalEvt.preventDefault()
            if(this.$refs.editModal.selectedUserRoles.length==0){
                this.$refs.editModal.showErrorAlert = true;
            }
            else{
                this.$axios
                .post(this.$apibase + '/api/users/set_user_group/', 
                {
                    user: this.userToEdit.uid,
                    groups: this.$refs.editModal.selectedUserRoles,
                    isNewUser: false
                },
                {
                    headers: {
                        Authorization:"JWT " + localStorage.getItem('access_token')
                    },
                })
                .then(() => {
                    this.$bvModal.hide('editModal');
                    this.userToEdit = null;
                    this.$store.dispatch('setAlert', {message: "Utente modificato con successo.", type: 'success'});
                })
                .catch((e)=> {
                    if (e.response.status == 403)
                        this.logout();
                    else
                        alert(e.response);
                })
            }
        },
        unverifyUser: function(bvModalEvt){
            bvModalEvt.preventDefault()
            this.$axios
            .patch(this.$apibase + '/api/users/' + this.userToUnverify.uid + '/',
                {
                    is_verified: false,
                    is_active: false
                },
                {
                    headers: {
                        Authorization:"JWT " + localStorage.getItem('access_token')
                    }
                }
            )
            .then(() => {
                this.$bvModal.hide('confirmDelete');
                let utente_index = this.listaUtenti.indexOf(this.userToUnverify);
                this.listaUtenti.splice(utente_index, 1);
                this.userToUnverify = null;
                this.$store.dispatch('setAlert', {message: "Utente rimosso con successo.", type: 'success'});
            })
            .catch((e)=>{
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e.response);
            })
        },
        getUsers: function() {
            this.$axios
            .get(this.$apibase + '/api/users/get_users/', {
                headers: {
                    Authorization:"JWT " + localStorage.getItem('access_token')
                }
            })
            .then(response => {             
                this.listaUtenti = response.data;
            })
            .catch((e)=> {
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e.response);
            })
        }
    }
}
</script>

<style scoped>
    .list-item-left{
        text-align: left;
    }
    .list-item-center{
        text-align: center;
    }
    .list-item-right{
        text-align: right;
    }
    .list-img-info{
        width: 15px;
        margin-right: 20px;
        cursor: pointer;
    }
    .list-img-delete{
        width:20px;
        cursor: pointer;
        
    }
    .list-img-delete-container{
        float: right;
    }
    .list-item {
        padding-left: 40px;
        padding-right: 40px;
    }
    /* .checkbox-item{
        padding-top: 20px;
        padding-bottom: 20px;
    } */
    /* .x-container{
        text-align: right;
        margin-bottom: 20px;
        padding-right: 30px;
        cursor: pointer;
    }
    .x-img{
        width: 15px;
    } */
    /* .editModalTitle{
        text-align: center;
        padding: 20px 0 40px;
    } */
    /* span,h1, label {
        color: #707070;
    } */
</style>